import { render, staticRenderFns } from "./knowledgeGraphDataSources.vue?vue&type=template&id=1dd6c8e1&scoped=true"
import script from "./knowledgeGraphDataSources.vue?vue&type=script&lang=js"
export * from "./knowledgeGraphDataSources.vue?vue&type=script&lang=js"
import style0 from "./knowledgeGraphDataSources.vue?vue&type=style&index=0&id=1dd6c8e1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6c8e1",
  null
  
)

export default component.exports